module.exports = "/images/ruler-modify-report.svg?f72eff0790793ef853b4f881f1b8d73b";